import { colors, fontFamilies } from '@configs/styles/config'
import { useAuth } from '@contexts/Auth'
import styled from '@emotion/styled'
import { Button } from '@nextui-org/react-latest'
import BadgeIcon from '@public/static/icons/advantageous/publishCourse/BadgeIcon'
import StartRingIcon from '@public/static/icons/advantageous/publishCourse/StartRingIcon'
import SuccessIcon from '@public/static/icons/advantageous/publishCourse/SuccessIcon'
import { useRouter } from 'next/router'
import { useTranslation } from 'react-i18next'

type Props = {
  isHomeLanding?: boolean
  handleBecomeCreator?: () => void
}

const PublishCourse = ({ isHomeLanding, handleBecomeCreator }: Props) => {
  const { t } = useTranslation('advantageous')
  const router = useRouter()
  const { user } = useAuth()

  const list = [
    {
      icon: BadgeIcon,
      title: 'bePrioritizedTitle',
      description: 'bePrioritizedDescription',
    },
    {
      icon: SuccessIcon,
      title: 'reapEarlyBenefitsTitle',
      description: 'reapEarlyBenefitsDescription',
    },
    {
      icon: StartRingIcon,
      title: 'beRecognizedTitle',
      description: 'beRecognizedDescription',
    },
  ]
  return (
    <Container>
      <Wrapper>
        <Top>
          <TopHeader>{t('publishCourseHeader')}</TopHeader>
          <TopContent>
            {list.map((item) => (
              <ContentItem key={item.description}>
                <ContentItemTop>
                  <ContentIcon className="bg-uguBrightPurple/10 rounded-full flex justify-center items-center">
                    <item.icon />
                  </ContentIcon>
                  <ContentTitle>{t(item.title)}</ContentTitle>
                </ContentItemTop>
                <ContentDescription>{t(item.description)}</ContentDescription>
              </ContentItem>
            ))}
          </TopContent>
        </Top>
        <Bottom>
          <BottomHeader>{t('publishNowBenefits')}</BottomHeader>
          <Button
            color="primary"
            className="px-[4rem] py-[2rem] lg:text-lg text-base font-sofiaPro rounded-full"
            onPress={() => {
              if (!handleBecomeCreator) {
                router.push('/author/become-author')
                return
              }
              handleBecomeCreator?.()
            }}
          >
            {t(
              user?.isAuthor
                ? 'Dasboard'
                : isHomeLanding
                  ? 'becomeCreatorButton'
                  : 'becomeAuthorButton'
            )}
          </Button>
        </Bottom>
      </Wrapper>
    </Container>
  )
}

export default PublishCourse

const Container = styled.div`
  min-height: 761px;
  max-width: 1650px;
  margin: 8rem auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
`
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6rem;
  padding: 0rem 2rem;
  width: 100%;
  align-items: center;
  @media screen and (max-width: 596px) {
    padding: 0px 1rem;
  }
`
const Top = styled.div`
  max-width: 1650px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4.5rem;
`
const TopHeader = styled.div`
  font-family: ${fontFamilies.bold};
  text-align: center;
  color: ${colors.uguPurple};
  max-width: 906px;
  font-size: 4rem;
  line-height: 4.3rem;
  @media screen and (max-width: 1024px) {
    line-height: 4rem;
    font-size: 4rem;
  }
  @media screen and (max-width: 596px) {
    font-size: 36px;
    line-height: 36px;
    text-align: left;
  }
`
const TopContent = styled.div`
  gap: 3.5rem;
  max-width: 1440px;
  display: flex;
  justify-content: space-evenly;
  flex-wrap: wrap;
  flex-direction: column;
  align-items: center;
  @media screen and (max-width: 596px) {
    justify-content: flex-start;
  }
  @media screen and (min-width: 821px) {
    display: flex;
    width: 100%;
    justify-content: space-evenly;
    flex-wrap: wrap;
    flex-direction: row;
  }
`

const ContentItem = styled.div`
  width: 366px;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  @media screen and (max-width: 1024px) {
    width: 360px;
  }
  @media screen and (max-width: 386px) {
    width: 100%;
  }
`
const ContentItemTop = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`
const ContentIcon = styled.div`
  width: 48px;
  height: 48px;
`
const ContentTitle = styled.div`
  font-family: ${fontFamilies.sofiaPro};
  font-weight: 600;
  text-align: left;
  color: ${colors.uguPurple};
  line-height: 24px;
  font-size: 24px;
  /* @media screen and (max-width: 1024px) {
    line-height: 24px;
    font-size: 24px; */
  /* } */
  @media screen and (max-width: 596px) {
    font-size: 24px;
    line-height: 24px;
  }
`
const ContentDescription = styled.div`
  font-family: ${fontFamilies.medium};
  text-align: left;
  color: ${colors.uguPurple};
  font-size: 18px;
  line-height: 23px;
  /* @media screen and (max-width: 1024px) {
    font-size: 18px;
    line-height: 18px;
  } */
  @media screen and (max-width: 596px) {
    font-size: 16px;
    line-height: 20px;
  }
`

const Bottom = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3rem;
  align-items: center;
`
const BottomHeader = styled.div`
  font-family: ${fontFamilies.medium};
  font-size: 36px;
  line-height: 49.03px;
  text-align: center;
  color: ${colors.uguPurple};
`
